import { Component, OnInit, Input, OnDestroy, ElementRef, EventEmitter, Output } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { NavService } from '../../services/nav.service'
import { Subject } from 'rxjs'
import { takeUntil, filter } from 'rxjs/operators'

@Component({
    selector: 'keycom-left-bar',
    templateUrl: './left-bar.component.html',
    styleUrls: ['./left-bar.component.scss'],
    standalone: false
})
export class LeftBarComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<void>()

  @Input() logo
  @Input() title
  @Input() user

  @Output() profileAction: EventEmitter<any> = new EventEmitter()
  @Output() helpAction: EventEmitter<any> = new EventEmitter()

  navButtons = []
  profileActions = []
  helpActions = []

  widthExp = 0
  heightExp = 0
  menuOn = false
  helpMenuOn = false

  collapsed = true
  isFeaturesActive = false
  isNotificationsActive = false

  constructor(private router: Router, private navService: NavService, private el: ElementRef) {}

  ngOnInit() {
    this.navService
      .getEntities$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((nav) => {
        this.navButtons = nav
        this.updateActiveStateFromRoute()
      })
    this.navService
      .getProfileActions$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((nav) => {
        this.profileActions = nav
      })
    this.navService
      .getHelpActions$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((nav) => {
        this.helpActions = nav
      })

    // Listen to route changes
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.onDestroy$)
      )
      .subscribe(() => {
        this.updateActiveStateFromRoute()
      })

    // Set initial active state
    this.updateActiveStateFromRoute()
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.unsubscribe()
  }

  clickProfile(profileAction) {
    this.close()
    this.profileAction.emit(profileAction)
  }

  clickHelp(helpAction) {
    this.close()
    this.helpAction.emit(helpAction)
  }

  show(event) {
    if (this.collapsed) {
      this.widthExp = event.target.offsetWidth + 34
    } else {
      this.widthExp = event.target.offsetWidth + 24
    }

    this.heightExp = 12
    this.menuOn = !this.menuOn
  }

  showHelp(event) {
    if (this.collapsed) {
      this.widthExp = event.target.offsetWidth + 34
    } else {
      this.widthExp = event.target.offsetWidth + 24
    }

    this.heightExp = 12
    this.helpMenuOn = !this.helpMenuOn
  }

  close() {
    this.menuOn = false
    this.helpMenuOn = false
  }

  select(event) {
    this.navButtons.forEach((button) => {
      button.active = false
    })

    event.active = true
    this.isFeaturesActive = false

    this.router.navigate([event.router])
  }

  toggleCollaped() {
    this.collapsed = !this.collapsed
  }

  navigateToFeatures() {
    this.navButtons.forEach((button) => {
      button.active = false
    })

    this.isFeaturesActive = true
    this.isNotificationsActive = false

    this.router.navigate(['feature-management'])
  }

  navigateToNotifications() {
    this.navButtons.forEach((button) => {
      button.active = false
    })

    this.isNotificationsActive = true
    this.isFeaturesActive = false

    this.router.navigate(['notification-management'])
  }

  updateActiveStateFromRoute() {
    const currentUrl = this.router.url

    if (currentUrl.includes('feature-management')) {
      this.isFeaturesActive = true
      this.isNotificationsActive = false
      this.navButtons.forEach((button) => {
        button.active = false
      })
    } else if (currentUrl.includes('notification-management')) {
      this.isNotificationsActive = true
      this.isFeaturesActive = false
      this.navButtons.forEach((button) => {
        button.active = false
      })
    } else {
      this.isFeaturesActive = false
      this.isNotificationsActive = false
      // Don't touch navButtons - they're managed by keySystemNavConfig.setNav()
    }
  }
}
